export default "__VITE_ASSET__CIv3hvBS__"